// MCP API endpoints — all relative to AP_API_BASE_URL
export const MCP_ENDPOINTS = {
    MCP_SERVER_BY_PROJECT: (projectId: string) => `/projects/${projectId}/mcp-server`,
    ROTATE_PROJECT_MCP_TOKEN: (projectId: string) => `/projects/${projectId}/mcp-server/rotate`,
    /** Full HTTP endpoint URL used in MCP client config */
    MCP_HTTP_SERVER_URL: (baseUrl: string, projectId: string) => `${baseUrl}/projects/${projectId}/mcp-server/http`,
    FLOW_BY_ID: (flowId: string) => `/flows/${flowId}`,
} as const;
